import { getAllOrgs } from "@/services/orgService";
import { useStore } from "@/store";

let allowedOrgsCache = null;

export const allowedOrganizations = async (workspace_organizations) => {
  const isStaff = useStore.isStaff();

  if (isStaff) {
    return workspace_organizations;
  }
  
  // Cache main backend orgs for the session
  if (!allowedOrgsCache) {
    const allowed_orgs = await getAllOrgs();
    allowedOrgsCache = allowed_orgs.map((item) => item.name?.toLowerCase());
  }
  
  const new_workspace_orgs = workspace_organizations.filter(item =>
    allowedOrgsCache.includes(item?.name?.toLowerCase())
  );
  
  return new_workspace_orgs;
};

// Clear cache on logout
export const clearAllowedOrgsCache = () => {
  allowedOrgsCache = null;
};